export const MEGOLI_CLINICA = '1'
export const MEGOLI_PEDIATRIA = '2'